// extracted by mini-css-extract-plugin
module.exports = {"load-more-card":"style_load-more-card__12bjp","view-more-button":"style_view-more-button__2Gb3U","view-more-plus-label":"style_view-more-plus-label__1HA3Q"};